import errors from './errors.json'
import {loggingUtils} from '../../../warmupUtils/index'

loggingUtils.logger.registerErrors('tpa', errors)

export default errors
